const EMAIL_ADDRESS_DELIMITERS = /[\r\n,;]+/;
const EMAIL_ADDRESS_SEPARATOR = ', ';

export const parseEmailAddresses = (value: string): string[] => {
  return value
    .split(EMAIL_ADDRESS_DELIMITERS)
    .map((emailAddress) => emailAddress.trim())
    .filter((emailAddress) => emailAddress.length > 0);
};

export const formatEmailAddresses = (emailAddresses: string[]): string => {
  return emailAddresses.join(EMAIL_ADDRESS_SEPARATOR);
};
